import React from "react";
import styles from "./style.module.css";

const Button = ({ active, onClick, text }) => {
  return <button  className={ active? styles.activeButton : styles.inactiveButton } onClick={onClick}>{text}</button>;
};

export default Button;
